import Community from '../../../assets/img/tentang-kami/community.png'
import Finance from '../../../assets/img/tentang-kami/finance.png'
import Calculator from '../../../assets/img/tentang-kami/calculator.png'
import TimelineLandscape from '../../../assets/img/tentang-kami/Timeline-Landscape.png'
import TimelinePotrait from '../../../assets/img/tentang-kami/Timeline-Potrait.png'

function Deskripsi() {
    return (
        <>
            <div className="breadcrumb-wrapper-kkb-detail" style={{ backgroundColor: 'white' }}>
                <div className="general-container">
                    <header>
                        <div className="ui-g-12">
                            <ul className="breadcrumb">
                                <li><a href="landing-page.xhtml">Beranda</a></li>
                                <li className="final">Tentang Kami</li>
                            </ul>
                        </div>
                    </header>
                </div>
            </div>

            <article className="tentang-kami-container">
                <div className="general-container">
                    <div className="ui-g">
                        <div className="ui-g-6 title">
                            <header>
                                <h2> Apa itu Danai.id? </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-6 deskripsi">
                            <p>
                                Danai.id menyediakan solusi pelayanan jasa keuangan dengan mengandalkan teknologi sebagai prasarana untuk menghadirkan solusi kepada
                                masyarakat.
                            </p>
                            <br />
                            <p>
                                Danai.id adalah platform yang terdaftar dan diawasi oleh Otoritas Jasa Keuangan (OJK) untuk memberikan layanan Pendanaan Bersama
                                Berbasis Teknologi Informasi.
                            </p>
                            <br />
                            <p>
                                PT Adiwisista Finansial Teknologi merupakan badan usaha yang menjadi pengelola dari platform Danai.id.
                            </p>
                        </div>
                    </div>

                    <div className="ui-g">
                        <div className="ui-g-6 title">
                            <header>
                                <h2> Siapa di Balik Danai.id </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-6 deskripsi">
                            <p>
                                Danai.id didukung oleh jajaran Manajemen yang berpengalaman luas di bidang jasa keuangan.
                                Seluruh jajaran Komisaris dan Direksi di Danai.id merupakan mantan manajemen senior di industri Perbankan dan regulatornya.
                            </p>
                            <br />
                            <p>
                                Pengalaman mereka sebelumnya sebagai praktisi dapat memberikan kepastian pelayanan praktik usaha terbaik yang diberikan kepada
                                nasabah Danai.id.
                            </p>
                            <br />
                            <p>
                                Profil Dewan Direksi dan Dewan Komisaris dapat dilihat
                                <a href="#myAnchor" className="anchorLink hover:bg-transparent focus:bg-transparent hover:text-[#29abe2] focus:text-[#29abe2]"
                                    style={{ borderBottom: 'none' }}> di sini.</a>
                            </p>
                        </div>
                    </div>

                    <div className="ui-g">
                        <div className="ui-g-6 title">
                            <header>
                                <h2> Visi dan Misi </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-6 deskripsi">
                            <p>
                                <strong>Visi Penyelenggara</strong>
                            </p>
                            <p>
                                Kami adalah Perusahaan Pelayanan Keuangan Digital yang menjembatani kebutuhan masyarakat dengan mendukung prinsip
                                inklusi keuangan dengan menggunakan teknologi sebagai sarana pelayanan
                            </p>
                            <br />
                            <p>
                                <strong>Misi Penyelenggara</strong>
                            </p>
                            <p>
                                Misi kami adalah menghadirkan pelayanan keuangan digital dengan memegang 5 prinsip, yaitu :
                            </p>
                            <p>1. <i><strong>D</strong>eference</i> (Patuh)</p>
                            <p>2. <i><strong>A</strong>ssured</i> (Aman)</p>
                            <p>3. <i><strong>N</strong>imble</i> (Cepat Tanggap)</p>
                            <p>4. <strong>A</strong>plikatif</p>
                            <p>5. <strong>I</strong>ntuitif</p>
                        </div>
                    </div>
                </div>
            </article>

            <article className="tentang-kami-container">
                <div className="general-container">
                    <div className='ui-g'>
                        <div className="ui-g-6 title">
                            <header>
                                <h2> Kenapa Memilih Kami </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-12 flex" style={{ marginBottom: '1%' }}>
                            <div className="pick-danai ui-g-3 ui-grid-col-3">
                                <img src={Community} className='pick-danai-community' alt='Community' />
                                <p className="pick-danai-desc">
                                    Memberikan pelayanan kepada Anda baik sebagai Peminjam atau Pemberi Pinjaman adalah prioritas kami.
                                </p>
                            </div>

                            <div className="pick-danai ui-g-3 ui-grid-col-3">
                                <img src={Finance} className='pick-danai-finance' alt='Finance' />
                                <p className="pick-danai-desc">
                                    Kami mengaplikasikan praktek industri terbaik dalam pengelolaan pelayanan keuangan Anda.
                                </p>
                            </div>

                            <div className="pick-danai ui-g-3 ui-grid-col-3">
                                <img src={Calculator} className='pick-danai-calculator' alt='Calculator' />
                                <p className="pick-danai-desc">
                                    Sebagai Pemberi Pinjaman Anda akan menikmati imbal hasil yang menarik dengan tahap resiko yang terukur.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="ui-g">
                        <div className="ui-g-6 title" style={{ marginBottom: '-1%' }}>
                            <header>
                                <h2> Cerita Perjalanan Kami </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-12">
                            <img src={TimelineLandscape} className='cerita-danai' alt='Timeline Landscape' />
                            <img src={TimelinePotrait} className='cerita-danai alt' alt='Timeline Potrait' />
                        </div>
                    </div>

                    <div className="ui-g" style={{ marginTop: '1%' }}>
                        <div className="ui-g-6 title">
                            <header>
                                <h2> Mengapa Kami Ada di Industri Ini </h2>
                                <span className="blue-line" />
                            </header>
                        </div>
                        <div className="ui-g-6 deskripsi">
                            <p>
                                Para pendiri Danai.id merupakan kumpulan praktisi Bank yang melihat terdapat kesenjangan yang cukup besar di Indonesia antara
                                masyarakat yang menikmati pelayanan keuangan dan yang belum pernah merasakan pelayanan tersebut.
                            </p>
                            <br />
                            <p>
                                Kesenjangan ini amat terlihat di kalangan masyarakat berpendapatan rendah dan yang berpendapatan menengah ke atas.
                            </p>
                            <br />
                            <p>
                                Dengan kesenjangan ini, dirasakan bahwa manfaat dari pertumbuhan ekonomi negara tidak dapat dinikmati sepenuhnya oleh golongan tertentu.
                            </p>
                            <br />
                            <p>
                                Danai.id hadir untuk menjembatani kesenjangan tersebut dengan mengandalkan solusi berbasis teknologi untuk memberikan
                                pelayanan keuangan kepada seluruh golongan masyarakat.
                            </p>
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}

export default Deskripsi;